import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react/index.js'
import Button, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'

import OptionComparator from '../../../../PublishYourAd/components/PageContent/components/OptionComparator/index.js'
import {useVehicleAppraiserAnalyticsTrack} from '../../hooks/useVehicleAppraiserAnalyticsTrack.js'

const SellOptionsBlock = ({
  bodyTypeDoors,
  fuelId,
  km,
  makeId,
  modelId,
  roundedRecommendPrice,
  transmissionTypeId,
  versionId,
  year,
  c2bAppraisal,
  onNavigateToVehicleExtraDataFormStep
}) => {
  const {domain, i18n} = useContext(Context)
  const router = useRouter()

  const BASE_CLASS = 'mt-VehicleAppraiserPage'

  const {trackOnClickPublishButton, trackOnClickChooseProssionalButton} = useVehicleAppraiserAnalyticsTrack()

  const handleOnClickPublishButton = async () => {
    const trackPromise = trackOnClickPublishButton()

    const obtainDraftPromise = domain.get('obtain_draft_ad_publisher_use_case').execute()

    const [
      {
        value: [draftError, draftResponse]
      }
    ] = await Promise.allSettled([obtainDraftPromise, trackPromise])

    if (!draftError) {
      const {
        data: {id: adId}
      } = draftResponse

      const fields = {
        bodyTypeDoors,
        fuelId,
        km,
        makeId,
        modelId,
        price: roundedRecommendPrice ? roundedRecommendPrice.toString() : null,
        publishInMA: true,
        transmissionTypeId,
        versionId,
        year
      }

      await domain.get('edit_draft_ad_publisher_use_case').execute({
        fields,
        adId
      })
    }

    const {PUBLISH_MY_AD_PATH_PATTERN} = domain.get('config').get('page')
    router.push(`${PUBLISH_MY_AD_PATH_PATTERN}?ptaFlow=appraiser`)
  }

  const handleOnClickChooseProfesional = async () => {
    onNavigateToVehicleExtraDataFormStep()
    trackOnClickChooseProssionalButton()
  }

  return (
    <div className={`${BASE_CLASS}-sellOptionsBlock`}>
      <div className={`${BASE_CLASS}-sellOptionsBlockList`}>
        <div className={`${BASE_CLASS}-sellOptionsBlockListCards`}>
          <div className={`${BASE_CLASS}-sellOptionsBlockCard`}>
            <h2>
              <span className={`${BASE_CLASS}-sellOptionsBlockCardPrice`}>
                {i18n.c(c2bAppraisal.priceRecommended.value)}
              </span>
              <span className={`${BASE_CLASS}-sellOptionsBlockCardSubtitle`}>
                {i18n.t('LANDING_VEHICLE_APPRAISER.SELL_OPTIONS_BLOCK.PROFESSIONAL_SALE_SUBTITLE')}
              </span>
            </h2>
            <p className={`${BASE_CLASS}-sellOptionsBlockCardDescription`}>
              {i18n.t('LANDING_VEHICLE_APPRAISER.SELL_OPTIONS_BLOCK.PROFESSIONAL_SALE_DESCRIPTION')}
            </p>
            <Button
              onClick={handleOnClickChooseProfesional}
              design={atomButtonDesigns.PRIMARY}
              shape={atomButtonShapes.CIRCULAR}
              size={atomButtonSizes.LARGE}
            >
              {i18n.t('LANDING_VEHICLE_APPRAISER.SELL_OPTIONS_BLOCK.CHOOSE_PROFESSIONAL_BUTTON_TEXT')}
            </Button>
          </div>
          <div className={`${BASE_CLASS}-sellOptionsBlockCard`}>
            <h2>
              <span className={`${BASE_CLASS}-sellOptionsBlockCardPrice`}>{i18n.c(roundedRecommendPrice)}</span>
              <span className={`${BASE_CLASS}-sellOptionsBlockCardSubtitle`}>
                {i18n.t('LANDING_VEHICLE_APPRAISER.SELL_OPTIONS_BLOCK.PARTICULAR_SALE_SUBTITLE')}
              </span>
            </h2>
            <p className={`${BASE_CLASS}-sellOptionsBlockCardDescription`}>
              {i18n.t('LANDING_VEHICLE_APPRAISER.SELL_OPTIONS_BLOCK.PARTICULAR_SALE_DESCRIPTION')}
            </p>
            <Button
              onClick={handleOnClickPublishButton}
              design={atomButtonDesigns.PRIMARY}
              shape={atomButtonShapes.CIRCULAR}
              size={atomButtonSizes.LARGE}
            >
              {i18n.t('LANDING_VEHICLE_APPRAISER.SELL_OPTIONS_BLOCK.PUBLISH_AD_BUTTON_TEXT')}
            </Button>
          </div>
        </div>
        <p>
          {htmlStringToReactElement(
            i18n.t('LANDING_VEHICLE_APPRAISER.SELL_OPTIONS_BLOCK.PRICE_NOTE', {
              highlightStart: '<strong>',
              highlightEnd: '</strong>'
            })
          )}
        </p>
      </div>

      <OptionComparator
        roundedRecommendPrice={roundedRecommendPrice}
        c2bAppraisal={c2bAppraisal}
        onChooseProfessional={handleOnClickChooseProfesional}
        onPublishAd={handleOnClickPublishButton}
      />
    </div>
  )
}

SellOptionsBlock.displayName = 'SellOptionsBlock'

SellOptionsBlock.propTypes = {
  bodyTypeDoors: PropTypes.string.isRequired,
  fuelId: PropTypes.string.isRequired,
  km: PropTypes.string.isRequired,
  makeId: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  roundedRecommendPrice: PropTypes.number,
  transmissionTypeId: PropTypes.string.isRequired,
  versionId: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  c2bAppraisal: PropTypes.object,
  onNavigateToVehicleExtraDataFormStep: PropTypes.func.isRequired
}

export default SellOptionsBlock
